import Vue from 'vue';
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import {
  store,
  SET_TOKEN_MUTATION,
  GET_CURRENT_USER_ACTION,
  GET_SPECIALTIES_ACTION,
  GET_SETTINGS_ACTION,
  GET_SOCIETIES_ACTION,
  GET_SUBSPECIALTIES_ACTION,
  GET_USER_QUESTIONNAIRE_ACTION, COOKIES, SWITCH_GUEST_USER_ROLE_ACTION,
} from './store';
import isEmpty from 'lodash/isEmpty';
import Api from '@/providers/Api.js';
import OpenIcon from '@/components/OpenIcon';
import VueWait from 'vue-wait';
import Toasted from 'vue-toasted';
import { Plugin } from 'vue-fragment';
import { loadFromStorage, saveToStorage } from './helpers/localStorageHelper';
import VueWindowSize from 'vue-window-size';
import { requestHandler } from '@/providers/Api.js';
import PortalVue from 'portal-vue';
import { initializeRefreshTokenInterceptor } from '@/helpers/refreshTokenInterceptorHelper';
import Dayjs from '@/plugins/Day';
import qs from 'qs';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import VueCookies from 'vue-cookies';

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(VueWait);
Vue.use(Toasted, {
  iconPack: 'custom-class',
});
Vue.use(Plugin);
Vue.use(VueWindowSize);
Vue.use(PortalVue);
Vue.use(Dayjs);
Vue.use(PerfectScrollbar);
Vue.use(VueCookies);

Vue.config.productionTip = false;

Vue.component('open-icon', OpenIcon);

function startApp(token = null) {
  if (token) {
    requestHandler.defaults.headers.common.Authorization = `Bearer ${token}`;
    store.commit(SET_TOKEN_MUTATION, token);
  }

  requestHandler.interceptors.request.use(function (config) {
    if (store.state.token) {
      config.headers.Authorization = `Bearer ${store.state.token}`;
    }
    return config;
  });
  if (Vue.$cookies.isKey(COOKIES.GUEST_CURRENT_ROLE)) {
    store.dispatch(SWITCH_GUEST_USER_ROLE_ACTION,{
      role: Vue.$cookies.get(COOKIES.GUEST_CURRENT_ROLE)
    });
  }

  requestHandler.interceptors.response.use(function (response) {
    return response;
  }, initializeRefreshTokenInterceptor(store));

  const initApp = () => {
    let loadingIndicator = document.getElementById('loading-indicator');
    loadingIndicator && (loadingIndicator.style.display = 'none');
    new Vue({
      router,
      store,
      render: (h) => h(App),
      created() {
        store.dispatch(GET_SPECIALTIES_ACTION);
        store.dispatch(GET_SUBSPECIALTIES_ACTION);

        if (store.getters.userIsGMAdmin) {
          store.dispatch(GET_SOCIETIES_ACTION);
        }
        if (store.state.user) {
          store.dispatch(GET_USER_QUESTIONNAIRE_ACTION);
        }
      },
      methods: {
        isEmpty(obj) {
          return isEmpty(obj);
        },
      },
      wait: new VueWait({}),
    }).$mount('#app');
    // save changes to demoMode, showAllResults (see SideBar.vue)
    store.watch(
      (state) => [
        state.userSettings.demoMode,
        state.userSettings.showAllResults,
      ],
      () => {
        Api.updateUser(this, store.state.user);
      }
    );
  };
  store.dispatch(GET_SETTINGS_ACTION);
  if (token) {
    store.dispatch(GET_CURRENT_USER_ACTION, null).finally(initApp);
  } else {
    initApp();
  }
}
const queryParams = qs.parse(window.location.hash.split('?')[1]);
if (queryParams && queryParams.token) {
  Api.signInUserByTempToken(queryParams.token)
    .then((data) => {
      saveToStorage('user-token', data.token);
      startApp(data.token);
    })
    .catch(() => {
      saveToStorage('user-token', null);
      startApp();
    });
} else {
  const token = loadFromStorage('user-token');
  startApp(token);
}
